import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './route-loader'

Vue.use(VueRouter)

const router = new VueRouter({
  base: '/admin/',
  routes
})
router.beforeEach((to, from, next) => {
  // 从路由的meta中获取title属性
  document.title = 'HERON6000';
  next();
});

export default router
